<template>
  <div>
    <top-header></top-header>
    <el-row :gutter="20" class="head-row">
      <el-col :span="8">
        <div class="head-div" style="background-color: #679922">
          <div style="padding-top: 10px;">
            <el-row>
              <span class="col-head-title">课程总览</span>
            </el-row>
            <el-row class="head-p" style="padding-top: 60px">
              <span class="head-p-title-around">课程</span>
              <span class="head-p-value-around">{{this.courseInfo.course}}</span>
            </el-row>
            <el-row class="head-p">
              <span class="head-p-title-around">直播</span>
              <span class="head-p-value-around">{{this.courseInfo.live}}</span>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="head-div" style="background-color: #6BC96B;">
          <div style="padding-top: 10px;">
            <el-row>
              <span class="col-head-title">今日直播</span>
            </el-row>
            <el-row class="head-p" style="padding-top: 10px">
              <span class="head-p-title-around">直播总数</span>
              <span class="head-p-value-around">{{this.liveCountInfo.total}}</span>
            </el-row>
            <el-row class="head-p">
              <span class="head-p-title-around">有效直播</span>
              <span class="head-p-value-around">{{this.liveCountInfo.used}}</span>
            </el-row>
            <el-row class="head-p">
              <span class="head-p-title-around">大班直播</span>
              <span class="head-p-value-around">{{this.liveCountInfo.big}}</span>
            </el-row>
            <el-row class="head-p">
              <span class="head-p-title-around">小班直播</span>
              <span class="head-p-value-around">{{this.liveCountInfo.samll}}</span>
            </el-row>
            <el-row class="head-p">
              <span class="head-p-title-around">双师直播</span>
              <span class="head-p-value-around">{{this.liveCountInfo.ass}}</span>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="head-div" style="background-color: #2EB1CD;">
          <div style="padding-top: 10px;">
            <el-row>
              <span class="col-head-title">账户总览</span>
            </el-row>
            <el-row class="head-p" style="padding-top: 60px">
              <span class="head-p-title-around">账户余额</span>
              <span class="head-p-value-around">{{this.curBalance.balance}}元</span>
            </el-row>
            <el-row class="head-p">
              <span class="head-p-title-around">累计消费</span>
              <span class="head-p-value-around">{{this.curBalance.avail}}元</span>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="head-row">
      <el-col :span="8">
        <div class="head-div" style="background-color: #8FD42D;">
          <div style="padding-top: 10px;">
            <el-row>
              <span class="col-head-title">用户信息</span>
            </el-row>
            <el-row class="head-p" style="padding-top: 20px">
              <span class="head-p-title-around">助教</span>
              <span class="head-p-value-around">{{this.userInfo.assistant}}</span>
            </el-row>
            <el-row class="head-p">
              <span class="head-p-title-around">学生</span>
              <span class="head-p-value-around">{{this.userInfo.student}}</span>
            </el-row>
            <el-row class="head-p">
              <span class="head-p-title-around">子管理员</span>
              <span class="head-p-value-around">{{this.userInfo['sub-admin']}}</span>
            </el-row>
            <el-row class="head-p">
              <span class="head-p-title-around">超级管理员</span>
              <span class="head-p-value-around">{{this.userInfo['super-admin']}}</span>
            </el-row>
            <el-row class="head-p">
              <span class="head-p-title-around">老师</span>
              <span class="head-p-value-around">{{this.userInfo.teacher}}</span>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="head-div" style="background-color: #52BF91;">
          <div style="padding-top: 10px;">
            <el-row>
              <span class="col-head-title">用户统计</span>
            </el-row>
            <el-row class="head-p" style="padding-top: 60px">
              <span class="head-p-title-around">用户UV</span>
              <span class="head-p-value-around">{{this.userUvPv.uv}}</span>
            </el-row>
            <el-row class="head-p">
              <span class="head-p-title-around">用户PV</span>
              <span class="head-p-value-around">{{this.userUvPv.pv}}</span>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="head-div" style="background-color: #248197;">
          <div style="padding-top: 10px;">
            <el-row>
              <span class="col-head-title">今日消费</span>
            </el-row>
            <el-row class="head-p" style="padding-top: 60px">
              <span class="head-p-title-around">直播消费</span>
              <span class="head-p-value-around">{{this.todayConsume.live}}</span>
            </el-row>
            <el-row class="head-p">
              <span class="head-p-title-around">回放消费</span>
              <span class="head-p-value-around">{{this.todayConsume.replay}}</span>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>

<!--    <el-row>-->
<!--      <p class="row-title">实时充值金额</p>-->
<!--      <div style="position: relative;">-->
<!--        <div class="statistic-account">-->
<!--          <AccountsChart :datas="investDatas" :labels="'充值（￥）'" :backgroundColor="'#f87979'"></AccountsChart>-->
<!--        </div>-->
<!--      </div>-->
<!--    </el-row>-->
<!--    <el-row style="padding-top: 20px">-->
<!--      <p class="row-title">实时消费金额</p>-->
<!--      <div style="position: relative; ">-->
<!--        <div class="statistic-account">-->
<!--          <AccountsChart :datas="spendDatas" :labels="'消费（￥）'" :backgroundColor="'#f87979'"></AccountsChart>-->
<!--        </div>-->
<!--      </div>-->
<!--    </el-row>-->
  </div>
</template>

<script>
import TopHeader from '../../components/TopHeader'
export default {
  name: 'Home',
  components: {TopHeader},
  data () {
    return {
      courseInfo: {},
      userInfo: {},
      liveCountInfo: {},
      userStatInfo: {},
      curBalance: 0,
      userUvPv: {},
      todayConsume: {}
    }
  },
  watch: {
    '$route': {
      handler (route) {
        const that = this
        if (route.path === '/') {
          console.log('----', route.path)
          that.getHomeData()
        }
      },
      deep: true
    }
  },
  created () {
    this.getHomeData()
  },
  methods: {
    getHomeData () {
      this.$api.home.getHomeCourseData().then((res) => {
        if (res.code === 0) {
          this.courseInfo = res.data
        }
      })
      this.$api.home.getHomeUserData().then((res) => {
        if (res.code === 0) {
          this.userInfo = res.data
        }
      })
      this.$api.home.getHomeTodayLive().then((res) => {
        if (res.code === 0) {
          this.liveCountInfo = res.data
        }
      })
      this.$api.recharge.getCurBalance().then((res) => {
        this.curBalance = res.data
      })
      this.$api.home.getHomeUserUvPv().then((res) => {
        this.userUvPv = res.data
      })
      this.$api.home.getHomeTodayConsume().then((res) => {
        this.todayConsume = res.data
      })
    }
  }
}
</script>

<style scoped>
  .row-title{
    font-family: "Microsoft Yahei", sans-serif;
    font-size: 20px;
    color: #000000;
    padding-left: 20px;
    padding-top: 10px;
  }
  .col-head-title{
    font-size: 30px;
    padding-top: 10px;
    color: white;
  }
  .head-row{
    padding-top: 20px;
    padding-right: 20px;
    padding-left: 20px;
  }
  .head-div{
    height: 260px;
    text-align: center;
  }
  .head-p-title{
    font-family: "Microsoft Yahei", sans-serif;
    padding: 10px;
    font-size: 18px;
    color: #FFFFFF;
  }
  .head-p-value{
    font-family: "Microsoft Yahei", sans-serif;
    font-size: 18px;
    color: #FFFFFF;
  }

  .head-p-title-around{
    font-family: "Microsoft Yahei", sans-serif;
    padding: 2px;
    font-size: 18px;
    color: #FFFFFF;
    width: 100px;
    flex: 1;
    text-align: left;
    margin-left: 15px;
  }
  .head-p-value-around{
    font-family: "Microsoft Yahei", sans-serif;
    font-size: 18px;
    padding: 2px;
    color: #FFFFFF;
    flex: 1;
    text-align: right;
    margin-right: 15px;
  }

  .head-p{
    display: flex;
    flex-direction: row;
    justify-content: space-around
  }
  .statistic-account{
    margin-top: 30px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/page/home/home.vue